

import React from 'react';
import { SellAnyFooterLogo } from './icons/SellAnyFooterLogo';
import { FacebookIcon } from './icons/FacebookIcon';
import { TwitterIcon } from './icons/TwitterIcon';
import { LinkedInIcon } from './icons/LinkedInIcon';
import { InstagramIcon } from './icons/InstagramIcon';

interface FooterProps {
    navigate: (path: string) => void;
}

const Footer: React.FC<FooterProps> = ({ navigate }) => {
    const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, path: string) => {
        e.preventDefault();
        navigate(path);
    };

    const menuLinks = [
        { href: '/about', label: 'About' },
        { href: '/residential', label: 'Apartments' },
        { href: '/residential', label: 'Villas' },
        { href: '/plots', label: 'Plots' },
        { href: '/commercial', label: 'Commercial' },
    ];

    const infoLinks = [
        { href: '/blog', label: 'Blog' },
        { href: '/buyers-guide', label: 'Buyers Guide' },
        { href: '/sellers-guide', label: 'Sellers Guide' },
    ];

    const helpLinks = [
        // { href: '/services', label: 'Support' },
        // { href: '/services', label: 'Legal Support' },
        { href: 'tel:9995123600', label: '9995 123 600' },
    ];

    const legalLinks = [
        { href: '/privacy-policy', label: 'Privacy policy' },
        // { href: '#', label: 'Terms of use' },
    ];

    const socialLinks = [
        { href: 'https://www.facebook.com/sellany.in', icon: <FacebookIcon className="w-6 h-6" /> },
        { href: 'https://www.instagram.com/sellany.in?utm_source=qr&igsh=MXJpaXVjbjJqaTEwZQ==', icon: <InstagramIcon className="w-6 h-6" /> },
        { href: 'https://www.youtube.com/@Sellanyproperties', icon: <span className="font-bold text-xs uppercase tracking-wider">Youtube</span> }, // Fallback if no icon
    ];

    const FooterLinkColumn = ({ title, links }: { title: string; links: { href: string; label: string }[] }) => (
        <div>
            <h4 className="text-sm font-medium text-gray-500">{title}</h4>
            <ul className="mt-4 space-y-3">
                {links.map((link) => (
                    <li key={link.label}>
                        <a
                            href={link.href}
                            onClick={(e) => link.href.startsWith('/') && handleNav(e, link.href)}
                            className="text-base font-medium text-gray-800 hover:text-brand-primary transition-all duration-200 inline-block hover:translate-x-1"
                        >
                            {link.label}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );

    return (
        <footer className="bg-white text-gray-800 border-t border-gray-200">
            <div className="container mx-auto py-8 px-3 sm:px-4 lg:px-6">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                        <SellAnyFooterLogo />
                    </div>
                    <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
                        <div>
                            <FooterLinkColumn title="Menu" links={menuLinks} />
                            <div className="mt-8">
                                <FooterLinkColumn title="Legal" links={legalLinks} />
                            </div>
                        </div>
                        <div>
                            <FooterLinkColumn title="Info" links={infoLinks} />
                        </div>
                        <div>
                            <FooterLinkColumn title="Contact Us" links={helpLinks} />
                        </div>
                    </div>
                </div>

                <div className="mt-12 border-t border-gray-200 pt-8 flex flex-col sm:flex-row items-center justify-between">
                    <p className="text-sm text-gray-500 order-2 sm:order-1 mt-4 sm:mt-0">
                        &copy; {new Date().getFullYear()} SellAny. All rights reserved.
                    </p>
                    <div className="flex space-x-4 order-1 sm:order-2 items-center">
                        {socialLinks.map((link, index) => (
                            <a key={index} href={link.href} target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-brand-primary transition-all duration-300 transform hover:scale-110 hover:-translate-y-1">
                                {link.icon}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;